/**
 * Safely parses JSON from localStorage to avoid "undefined is not valid JSON" errors
 * @param {string} key - localStorage key
 * @param {any} defaultValue - default value to return if parsing fails
 * @returns {any} parsed value or default value
 */
export const safeGetFromLocalStorage = (key, defaultValue = null) => {
  try {
    const item = localStorage.getItem(key);
    if (item === null || item === undefined || item === 'undefined') {
      return defaultValue;
    }
    return JSON.parse(item);
  } catch (error) {
    console.warn(`Failed to parse localStorage item "${key}":`, error);
    return defaultValue;
  }
};

/**
 * Safely parses JSON string with fallback
 * @param {string} jsonString - JSON string to parse
 * @param {any} defaultValue - default value to return if parsing fails
 * @returns {any} parsed value or default value
 */
export const safeJSONParse = (jsonString, defaultValue = null) => {
  try {
    if (jsonString === null || jsonString === undefined || jsonString === 'undefined') {
      return defaultValue;
    }
    return JSON.parse(jsonString);
  } catch (error) {
    console.warn('Failed to parse JSON:', error);
    return defaultValue;
  }
};